var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 583,
    height: 259,
    viewBox: "0 0 583 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_626_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.875 253.232C323.884 254.194 318.945 251.607 317.108 247.046C316.571 245.702 315.843 243.878 315.219 242.535C314.405 240.744 312.568 239.583 310.523 239.549C309.05 239.533 306.988 239.599 305.446 239.632C300.368 239.782 295.932 236.431 294.927 231.655C294.355 228.952 294.927 226.232 296.573 223.993C298.168 221.804 297.665 218.818 295.464 217.193C289.295 212.682 283.559 207.524 278.395 201.885L277.875 201.305C276.645 199.928 274.739 199.315 272.902 199.68C272.763 199.713 272.625 199.729 272.486 199.779C257.427 203.925 243.685 207.209 231.624 209.548C184.247 218.719 174.82 210.609 171.857 203.71C169.067 197.208 169.344 185.914 204.019 163.11C205.735 161.982 206.584 159.976 206.168 158.019C205.752 156.062 204.158 154.536 202.113 154.138C160.922 146.011 156.053 135.745 156.001 128.713C155.931 121.25 161.303 110.254 208.611 101.1C220.898 98.728 235.159 96.6052 251.05 94.7974C251.189 94.7974 251.327 94.7642 251.466 94.7311C253.268 94.3828 254.758 93.1389 255.365 91.4473C266.369 60.4006 290.733 35.4737 322.22 23.0682C329.117 20.3483 336.326 18.2586 343.621 16.8323C357.883 14.0627 372.422 13.8637 386.875 16.2187C387.516 16.3182 388.157 16.3182 388.781 16.1855C389.543 16.0362 390.254 15.7377 390.878 15.2734C392.021 14.4441 392.749 13.2002 392.905 11.8403C393.39 7.52825 396.717 4.06205 401.171 3.19964C406.162 2.23772 411.1 4.82497 412.937 9.38578C413.475 10.7126 414.202 12.5369 414.826 13.8802C415.641 15.6714 417.478 16.8324 419.522 16.8489C420.995 16.8655 423.057 16.8157 424.582 16.766C429.677 16.6167 434.096 19.9668 435.101 24.7433C435.5 26.6339 435.326 28.5744 434.599 30.3655C433.732 32.4718 434.477 34.8766 436.383 36.2034C443.332 41.0295 449.709 46.5688 455.376 52.672C456.606 53.9988 458.495 54.5959 460.297 54.2476C460.436 54.2144 460.575 54.1813 460.713 54.1481C475.997 49.919 489.93 46.5855 502.13 44.2138C549.455 35.0424 558.882 43.169 561.845 50.0683C564.653 56.6027 564.323 67.9632 529.145 91.016C527.413 92.1438 526.563 94.1672 526.997 96.1408C527.43 98.1144 529.042 99.6402 531.104 100.022C572.277 107.634 577.649 117.419 577.719 125.065C577.788 132.528 572.399 143.523 525.021 152.695C513.047 155.017 499.114 157.09 483.605 158.881C483.466 158.881 483.328 158.914 483.189 158.947C481.37 159.296 479.862 160.573 479.273 162.281C476.916 169.197 473.866 175.93 470.192 182.282C457.092 204.887 436.955 222.036 411.984 231.887C404.949 234.657 397.653 236.78 390.288 238.206C374.762 241.208 358.992 241.175 343.431 238.09C342.738 237.957 342.027 237.957 341.351 238.09C340.502 238.256 339.705 238.621 339.047 239.151C337.834 240.13 337.14 241.589 337.192 243.115C337.348 247.975 333.848 252.22 328.857 253.182L328.875 253.232Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.862 170.855L248.935 176.66C242.142 177.97 235.453 173.725 234.066 167.223C232.697 160.722 237.134 154.32 243.927 152.994L273.854 147.205C280.647 145.895 287.336 150.141 288.722 156.642C290.091 163.143 285.655 169.545 278.862 170.872V170.855Z",
    fill: "#1D074F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.266 130.189L240.339 135.994C233.546 137.304 226.857 133.059 225.471 126.557C224.102 120.056 228.538 113.654 235.331 112.328L265.258 106.523C272.051 105.213 278.74 109.458 280.126 115.96C281.495 122.461 277.059 128.863 270.266 130.189Z",
    fill: "#1D074F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491.35 129.692L461.423 135.496C454.63 136.806 447.941 132.561 446.555 126.059C445.186 119.558 449.622 113.157 456.415 111.83L486.342 106.025C493.135 104.715 499.824 108.961 501.21 115.462C502.579 121.963 498.143 128.365 491.35 129.692Z",
    fill: "#1D074F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M482.754 89.0258L452.827 94.8305C446.034 96.1407 439.345 91.895 437.959 85.3937C436.59 78.8925 441.026 72.4908 447.819 71.164L477.746 65.3759C484.539 64.0657 491.228 68.3114 492.615 74.8126C493.984 81.3139 489.547 87.7156 482.754 89.0424V89.0258Z",
    fill: "#1D074F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M456.242 65.5416C445.879 51.8591 432.397 41.0458 417.165 33.6159C389.525 20.1324 356.132 17.8271 325.183 30.0169C291.201 43.4009 267.962 71.197 259.991 102.973C257.773 111.813 256.733 120.935 256.976 130.172C257.305 142.694 259.957 155.381 265.242 167.654C269.99 178.683 276.488 188.518 284.269 197.009C299.068 213.179 318.563 224.474 339.895 229.698C362.093 235.138 386.233 234.01 409.055 225.037C433.09 215.568 451.719 198.9 463.416 178.716C476.725 155.746 481.005 128.232 473.9 101.564C472.635 96.8039 471.023 92.0772 469.013 87.4003C465.617 79.4894 461.285 72.1921 456.259 65.5582L456.242 65.5416Z",
    fill: "url(#paint0_linear_626_951)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 256,
    y: 22,
    width: 222,
    height: 211
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M456.244 65.5416C445.881 51.8591 432.399 41.0458 417.167 33.6159C389.527 20.1324 356.134 17.8271 325.185 30.0169C291.203 43.4009 267.964 71.197 259.993 102.973C257.775 111.813 256.735 120.935 256.978 130.172C257.307 142.694 259.958 155.381 265.244 167.654C269.992 178.683 276.49 188.518 284.271 197.009C299.07 213.179 318.565 224.474 339.897 229.698C362.095 235.138 386.235 234.01 409.057 225.037C433.092 215.568 451.721 198.9 463.418 178.716C476.727 155.746 481.007 128.232 473.902 101.564C472.637 96.8039 471.025 92.0772 469.015 87.4003C465.619 79.4894 461.286 72.1921 456.261 65.5582L456.244 65.5416Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.685 15.4719C441.061 26.1194 429.884 33.7152 418.88 35.5064C411.134 36.7668 403.215 36.0039 395.365 36.2693C387.515 36.5346 379.266 38.0438 373.374 42.9861C364.554 50.3829 369.302 82.0764 358.679 86.8363C346.22 92.4253 339.756 54.2471 314.04 58.6255C295.74 61.7435 297.525 100.618 288.202 105.096C277.406 110.287 263.335 87.1514 251.326 88.3786C237.186 89.8215 224.674 100.734 221.85 114.085L251.361 182.713L483.153 91.4137L441.668 15.4553L441.685 15.4719Z",
    fill: "url(#paint1_linear_626_951)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.328 49.5371C455.704 60.1845 445.913 84.1164 434.909 85.9075C427.163 87.168 412.919 62.5893 406.732 57.9622C396.179 50.0678 389.178 62.2908 390.01 76.3215C390.668 87.5328 388.814 111.713 378.191 116.49C365.732 122.079 338.855 97.7491 325.875 102.144C316.032 105.461 311.111 116.374 301.788 120.868C290.992 126.059 277.995 121.25 265.986 122.477C251.846 123.92 239.334 134.833 236.51 148.183L270.908 228.172L502.7 136.873L456.328 49.5703V49.5371Z",
    fill: "url(#paint2_linear_626_951)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.855 92.6079C474.231 103.255 463.054 110.851 452.05 112.642C444.304 113.903 436.385 113.14 428.535 113.405C420.685 113.671 412.436 115.18 406.544 120.122C397.724 127.519 395.558 141.367 384.935 146.127C372.476 151.716 357.365 140.803 344.403 145.182C334.56 148.499 329.638 159.411 320.315 163.906C309.519 169.097 296.523 164.287 284.514 165.515C270.373 166.957 257.862 177.87 255.037 191.221L289.435 271.209L521.227 179.91L474.855 92.6079Z",
    fill: "url(#paint3_linear_626_951)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.242 208.784C283.525 215.932 315.879 221.19 325.011 215.053C331.44 210.741 323.035 199.862 323.451 192.349C323.902 184.156 335.755 180.159 343.328 182.116C357.659 185.814 389.232 201.205 400.288 197.44C413.25 193.029 370.794 164.702 406.596 158.234C416.855 156.376 427.564 158.4 437.476 155.298C448.965 151.716 454.649 139.543 464.076 132.328C475.184 123.837 492.097 123.157 503.915 130.72L533.427 199.347L301.634 290.647L275.242 208.751V208.784Z",
    fill: "url(#paint4_linear_626_951)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.191 243.048C324.856 239.101 332.221 232.832 338.286 225.7C341.44 222.002 344.316 218.022 348.059 214.837C354.02 209.779 362.078 207.026 370.032 207.358C374.59 207.54 383.306 211.952 387.483 213.743C409.802 223.246 415.764 210.857 424.081 195.466C427.773 188.65 433.734 183.127 439.591 177.886C445.465 172.646 454.165 169.146 461.512 172.198C465.775 173.972 469.31 177.804 473.972 177.853C476.502 177.886 478.928 176.742 481.458 176.908C486.137 177.206 489.325 182.082 489.204 186.56C489.082 191.038 486.587 195.118 484.022 198.883C462.968 229.797 432.399 255.42 396.06 267.759C381.452 272.718 365.769 275.521 350.399 273.664C335.634 271.889 321.892 265.935 308.809 259.45C305.707 257.908 293.404 253.944 295.743 248.836C296.904 246.299 301.514 247.128 303.905 246.763C308.151 246.1 312.31 244.823 316.191 243.048Z",
    fill: "url(#paint5_linear_626_951)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M456.242 65.5416C445.879 51.8591 432.397 41.0458 417.165 33.6159C389.525 20.1324 356.132 17.8271 325.183 30.0169C291.201 43.4009 267.962 71.197 259.991 102.973C257.773 111.813 256.733 120.935 256.976 130.172C257.305 142.694 259.957 155.381 265.242 167.654C269.99 178.683 276.488 188.518 284.269 197.009C299.068 213.179 318.563 224.474 339.895 229.698C362.093 235.138 386.233 234.01 409.055 225.037C433.09 215.568 451.719 198.9 463.416 178.716C476.725 155.746 481.005 128.232 473.9 101.564C472.635 96.8039 471.023 92.0772 469.013 87.4003C465.617 79.4894 461.285 72.1921 456.259 65.5582L456.242 65.5416Z",
    stroke: "#1D074F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M554.652 52.9703C559.106 63.3026 527.411 86.3886 476.152 112.51C448.616 126.524 415.449 141.434 379.214 155.713C342.962 169.993 308.442 181.735 278.567 190.325C222.959 206.297 183.483 211.239 179.047 200.907C174.593 190.541 206.409 167.389 257.824 141.218C258.327 144.966 259.055 148.698 260.008 152.429C246.197 160.091 238.589 165.797 239.664 168.317C240.721 170.772 249.87 169.827 264.6 166.211C288.271 160.407 326.395 147.686 368.609 131.051C410.805 114.433 447.23 97.7824 468.319 85.9574C481.455 78.5938 488.646 73.1042 487.589 70.6496C486.515 68.1287 476.897 69.2068 461.44 73.071C459.36 69.7873 457.142 66.6361 454.734 63.6343C510.516 47.5802 550.147 42.5882 554.618 52.9537L554.652 52.9703Z",
    fill: "url(#paint6_linear_626_951)",
    stroke: "#1D074F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.797 128.68C163.901 139.858 202.475 149.328 260.302 154.32C291.373 156.99 327.972 158.383 367.152 158.035C406.351 157.703 442.932 155.68 473.934 152.463C531.656 146.476 570.023 136.342 569.919 125.164C569.832 115.429 542.088 107.85 496.444 102.542C490.205 105.528 485.145 108.015 477.417 111.847C493.255 113.77 500.793 114.981 500.828 117.701C500.845 120.355 492.042 122.892 477.001 125.031C452.827 128.498 412.537 130.969 366.892 131.35C321.265 131.748 280.941 129.974 256.697 126.922C241.604 125.031 232.749 122.643 232.714 119.99C232.697 117.27 241.985 114.683 257.789 112.493C258.361 108.695 259.141 104.964 260.129 101.315C202.215 107.286 163.676 117.436 163.78 128.647L163.797 128.68Z",
    fill: "url(#paint7_linear_626_951)",
    stroke: "#1D074F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M411.066 49.9688C409.818 50.2175 408.588 49.5542 408.12 48.4264C403.389 36.6512 402.124 35.8551 388.954 36.2532C387.689 36.2863 386.58 35.4571 386.32 34.263C386.06 33.0689 386.753 31.8914 387.932 31.4436C400.235 26.916 401.067 25.7053 400.651 13.1008C400.616 11.8901 401.483 10.8287 402.731 10.5799C403.978 10.3311 405.209 10.9946 405.677 12.1223C410.407 23.8975 411.672 24.6936 424.842 24.2956C426.107 24.2624 427.216 25.0916 427.476 26.2857C427.736 27.4798 427.043 28.6573 425.865 29.1051C413.561 33.6328 412.729 34.8435 413.145 47.4479C413.18 48.6586 412.314 49.72 411.066 49.9688Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M403.25 13.0178C408.379 25.7715 410.65 27.2144 424.929 26.7832C411.603 31.6923 410.095 33.8649 410.546 47.5308C405.416 34.7771 403.146 33.3341 388.867 33.7653C402.193 28.8563 403.701 26.6836 403.25 13.0178ZM402.21 8.14188C399.732 8.62284 397.965 10.7457 398.051 13.1836C398.433 24.6935 398.225 24.992 386.995 29.1382C384.621 30.0172 383.27 32.3888 383.772 34.777C384.275 37.1487 386.493 38.8403 389.04 38.7574C401.067 38.3925 401.379 38.5915 405.711 49.3385C406.629 51.6106 409.107 52.9042 411.585 52.4232C414.063 51.9423 415.831 49.8194 415.744 47.3814C415.363 35.8716 415.571 35.5731 426.8 31.4269C429.174 30.5479 430.526 28.1763 430.023 25.8047C429.521 23.433 427.303 21.7414 424.755 21.8243C412.729 22.1892 412.417 21.9902 408.085 11.2432C407.166 8.97112 404.688 7.67748 402.21 8.15843V8.14188Z",
    fill: "#1D074F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M327.314 245.918C326.066 246.167 324.836 245.503 324.368 244.375C319.637 232.6 318.372 231.804 305.202 232.202C303.937 232.235 302.828 231.406 302.568 230.212C302.308 229.018 303.001 227.84 304.18 227.393C316.483 222.865 317.315 221.654 316.899 209.05C316.865 207.839 317.731 206.778 318.979 206.529C320.226 206.28 321.457 206.943 321.925 208.071C326.655 219.846 327.92 220.643 341.09 220.244C342.355 220.211 343.464 221.041 343.724 222.235C343.984 223.429 343.291 224.606 342.113 225.054C329.809 229.582 328.977 230.792 329.393 243.397C329.428 244.608 328.562 245.669 327.314 245.918Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M319.498 208.967C324.627 221.721 326.898 223.164 341.177 222.732C327.851 227.641 326.343 229.814 326.794 243.48C321.664 230.726 319.394 229.283 305.115 229.715C318.441 224.805 319.949 222.633 319.498 208.967ZM318.458 204.091C315.98 204.572 314.213 206.695 314.299 209.133C314.681 220.643 314.473 220.941 303.244 225.087C300.869 225.966 299.518 228.338 300.02 230.726C300.523 233.098 302.741 234.789 305.288 234.707C317.315 234.342 317.627 234.541 321.959 245.288C322.877 247.56 325.355 248.853 327.833 248.372C330.311 247.891 332.079 245.769 331.992 243.331C331.611 231.821 331.819 231.522 343.048 227.376C345.422 226.497 346.774 224.125 346.271 221.737C345.769 219.366 343.551 217.674 341.003 217.757C328.977 218.122 328.665 217.923 324.333 207.176C323.414 204.904 320.936 203.61 318.458 204.091Z",
    fill: "#1D074F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_626_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.145 22.2406L253.124 22.1923C252.664 21.0922 251.974 19.4501 251.07 18.1622C251.013 17.9904 250.95 17.8295 250.877 17.6738C250.009 15.8922 247.934 14.996 245.049 15.1409C242.608 15.2643 239.733 16.1176 236.962 17.545C234.192 18.9725 231.803 20.8239 230.245 22.7611C228.405 25.0526 227.867 27.2903 228.735 29.0666C228.777 29.1578 228.829 29.2437 228.886 29.3349C229.289 30.8912 230.219 32.4689 230.847 33.526C231.045 33.8641 231.233 34.1807 231.322 34.3578C232.122 35.9999 233.983 36.9068 236.555 36.9068C236.748 36.9068 236.947 36.9068 237.15 36.8907C239.591 36.7673 242.466 35.9141 245.237 34.4866C251.546 31.24 255.085 26.2815 253.459 22.9597C253.375 22.7933 253.271 22.5411 253.145 22.2352V22.2406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.053 23.6894C253.234 26.1097 249.868 30.3008 244.531 33.0484C239.194 35.7959 233.91 36.0589 232.728 33.6387C232.106 32.3615 229.158 28.3528 230.69 26.5658C232.059 24.9613 236.758 23.5929 239.278 22.2996C241.949 20.9258 245.524 17.7113 247.657 17.604C249.795 17.4967 251.457 22.4874 252.048 23.6948L252.053 23.6894Z",
    fill: "url(#paint8_linear_626_951)",
    stroke: "#1D074F",
    strokeWidth: 2.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.946 27.7433C247.283 24.9961 250.65 20.806 249.467 18.3845C248.285 15.963 243 16.227 237.663 18.9742C232.326 21.7214 228.959 25.9115 230.141 28.333C231.324 30.7545 236.609 30.4905 241.946 27.7433Z",
    fill: "url(#paint9_linear_626_951)",
    stroke: "#1D074F",
    strokeWidth: 2.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.619 20.3892C245.116 21.4034 243.218 23.4104 240.385 24.8647C237.552 26.3244 234.855 26.6839 234.358 25.6697C233.862 24.6554 235.759 22.6484 238.592 21.1941C241.425 19.7345 244.122 19.3749 244.619 20.3892Z",
    fill: "url(#paint10_linear_626_951)",
    stroke: "#1D074F",
    strokeWidth: 1.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_626_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2964 182.02C50.0898 178.498 39.7356 176.728 31.1163 177.034C20.9097 177.388 13.8962 180.621 11.3861 186.17C11.2569 186.46 11.1646 186.749 11.0723 187.039C8.02695 191.06 6.16282 196.368 4.92622 199.923C4.55709 201.001 4.15104 202.111 3.9111 202.674C-0.795362 213.033 13.1395 226.866 36.3027 234.876C45.8263 238.158 55.2208 239.895 63.4894 239.895C74.8218 239.895 82.5183 236.646 85.213 230.742C85.4529 230.212 85.8405 229.472 86.3204 228.587L86.3942 228.426C88.2583 224.936 90.7685 220.223 91.9312 215.622C92.245 215.156 92.5034 214.689 92.7064 214.239C95.2165 208.69 92.6695 202.159 85.4898 195.805C79.436 190.449 70.4845 185.559 60.2964 182.036V182.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0261 228.941C76.5931 236.485 57.9334 237.128 38.3323 230.356C18.7313 223.585 5.627 211.987 9.05995 204.443C10.8687 200.454 14.2094 185.704 22.4226 185.64C29.7499 185.591 44.3308 193.634 53.5776 196.835C63.3781 200.213 80.0445 201.998 85.3416 206.695C90.6387 211.392 81.761 225.161 80.0445 228.941H80.0261Z",
    fill: "url(#paint11_linear_626_951)",
    stroke: "#1D074F",
    strokeWidth: 2.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5202 212.437C84.0873 219.981 65.4275 220.625 45.8265 213.853C26.2254 207.081 13.1211 195.484 16.5541 187.94C19.987 180.396 38.6468 179.752 58.2478 186.524C77.8489 193.296 90.9532 204.893 87.5202 212.437Z",
    fill: "url(#paint12_linear_626_951)",
    stroke: "#1D074F",
    strokeWidth: 2.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0012 205.279C69.5616 208.448 59.9641 208.094 49.5545 204.507C39.1449 200.92 31.8729 195.435 33.3126 192.283C34.7522 189.114 44.3497 189.468 54.7593 193.055C65.1689 196.642 72.4408 202.127 71.0012 205.279Z",
    fill: "url(#paint13_linear_626_951)",
    stroke: "#1D074F",
    strokeWidth: 1.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_626_951",
    x: 153,
    y: 0,
    width: 429.719,
    height: 258.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_626_951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_626_951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_626_951",
    x: 225.33,
    y: 12.1257,
    width: 33.5234,
    height: 29.781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_626_951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_626_951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_626_951",
    x: 0,
    y: 174,
    width: 98.6465,
    height: 70.8948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_626_951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_626_951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_626_951",
    x1: 342.18,
    y1: 18.3148,
    x2: 365.073,
    y2: 127.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_626_951",
    x1: 338.272,
    y1: 35.5356,
    x2: 362.609,
    y2: 161.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0FD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_626_951",
    x1: 353.083,
    y1: 64.5292,
    x2: 380.658,
    y2: 206.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9643E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8337C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7730B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732EB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_626_951",
    x1: 381.417,
    y1: 153.952,
    x2: 408.05,
    y2: 291.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4AD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27C000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0CAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_626_951",
    x1: 391.392,
    y1: 143.018,
    x2: 415.717,
    y2: 268.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF0FE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FF63BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_626_951",
    x1: 385.207,
    y1: 184.42,
    x2: 401.405,
    y2: 268.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0FD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_626_951",
    x1: 356.912,
    y1: 80.0487,
    x2: 375.144,
    y2: 174.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDFE0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDCC0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_626_951",
    x1: 356.912,
    y1: 80.049,
    x2: 375.147,
    y2: 174.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDFE0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDCC0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_626_951",
    x1: 241.269,
    y1: 17.5986,
    x2: 241.269,
    y2: 35.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4AD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27C000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0CAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_626_951",
    x1: 239.803,
    y1: 22.4925,
    x2: 239.803,
    y2: 35.7528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4AD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27C000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0CAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_626_951",
    x1: 239.486,
    y1: 19.815,
    x2: 239.486,
    y2: 26.2492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4AD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27C000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0CAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_626_951",
    x1: 47.7453,
    y1: 185.64,
    x2: 47.7453,
    y2: 235.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF0FE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FF63BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_626_951",
    x1: 52.0279,
    y1: 181.843,
    x2: 52.0279,
    y2: 218.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF0FE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FF63BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_626_951",
    x1: 52.1753,
    y1: 190.127,
    x2: 52.1753,
    y2: 207.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF0FE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FF63BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBanner);
export default __webpack_public_path__ + "static/media/img_banner.c84cd2b2ef1ca844c5359924464d6f1e.svg";
export { ForwardRef as ReactComponent };